<template>
    <div class="form-section">
        <slot />
    </div>
</template>

<style lang="scss">
.form-section {
    margin-block-end: 20px;
    overflow: hidden;
}
</style>
